<template>
  <div
    ref="outcomeWrap"
    :class="['m-outcome', changeType, {
      'active': active && !isDisabled,
      'disabled': isDisabled,
      'm-outcome--up': isUp,
      'm-outcome--down': isDown,
      'multiple': showDesc,
      'in-oddsRange': inOddsRange,
      'odds-disabled': (isLoading || isConflict) && !isDisabled && !active
    }]"
    @click.stop="toogleSelected"
  >
    <keep-alive>
      <i
        v-if="!isDisabled && (isUp || isDown)"
        :class="['m-icon-arrow', {
          'up': isUp,
          'down': isDown
        }]"
      />
    </keep-alive>

    <div
      v-if="showDesc"
      class="desc"
    >
      {{ description || outcome.description }}
    </div>

    <img
      v-if="isDisabled"
      width="19px"
      src="~public/images/icon/locked.svg"
      alt="disabled"
    >

    <div
      v-else
      class="odds"
    >
      {{ outcome.odds }}
      <div
        v-if="isLoading"
        class="odds-loading"
        :style="{ '--time': moveTime }"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import toast from 'fe-vui/toast'
import { useAuthStore } from '@ms/stores/auth'
import { useWapBetslipStore } from 'wap/stores/betslip'
import { useDetailStore } from '@ms/stores/matchDetail/index'
import { isSelectedSelection, convertSelectionOutcome } from '@ms/stores/betslip/func'
import useOutcome from '@ms/components/match/useOutcome.js'
import useOddsRange from 'composables/useOddsRange.js'

export default {
  name: 'MatchOutcome',
  props: {
    outcome: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    market: {
      type: Object,
      default: () => null
    },
    event: {
      type: Object,
      default: () => null
    },
    // 显示类型，默认为空, multiple 支持 desc + odds
    changeType: {
      type: String,
      default: ''
    },
    showDesc: {
      type: Boolean,
      default: false
    },
    // 自定义 desc
    description: {
      type: String,
      default: ''
    },
    keyPoints: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const outcomeWrap = ref(null)
    const isLoading = ref(false)
    const isConflict = ref(false)
    const moveTime = ref(0)
    const outcomeWidth = ref(0)
    const { selectionList } = storeToRefs(useWapBetslipStore())

    const { loading, conflictMarkets, curConflictMarkets } = storeToRefs(useDetailStore())

    const { active, selectionId, isDisabled, isUp, isDown, updateStatus } = useOutcome(props, selectionList)
    const { oddsRange } = useOddsRange()

    watch(outcomeWidth, (val) => {
      moveTime.value = val / 150
    })

    watch(loading, (val) => {
      if (!props.market || !val) {
        isLoading.value = val
        return false
      }

      const { comboType } = props.market
      if (comboType) {
        isLoading.value = val
      }
    })

    watch(isLoading, (val) => {
      if (!val || !outcomeWrap.value || moveTime.value) return false
      outcomeWidth.value = outcomeWrap.value.offsetWidth
    })

    watch(
      conflictMarkets,
      (val) => {
        if (!props.market) return
        const { id, specifiers, comboType } = props.market
        if (!comboType || isDisabled.value || !val.length) {
          isConflict.value = false
          return false
        }
        const { id: outcomeId } = props.outcome
        const _specifiers = specifiers || null
        const arr = val.filter((x) => x.id === id && x.specifiers === _specifiers)
        const status = arr.some((x) => x.outcomes.some((x) => x.id === outcomeId))

        isConflict.value = status
      },
      { immediate: true }
    )

    return {
      outcomeWrap,
      isLoading,
      isConflict,
      active,
      selectionId,
      isDisabled,
      isUp,
      isDown,
      moveTime,
      updateStatus,
      oddsRange,
      selectionList,
      curConflictMarkets
    }
  },
  computed: {
    inOddsRange() {
      if (this.isDisabled || !this.oddsRange) return false
      const { outcome = {}, oddsRange } = this
      if (outcome && outcome.odds && oddsRange.length && oddsRange.length === 2) {
        if (outcome.odds >= oddsRange[0] && outcome.odds <= oddsRange[1]) return true
      }
      return false
    }
  },
  watch: {
    'market.specifiers': function () {
      this.$nextTick(() => {
        this.updateStatus(0)
      })
      // 切换 specifiers 要重新选择
      this.onSelectionsChange()
    },
    active(val) {
      const { group } = this.$route.query
      if (val && decodeURIComponent(group) === 'Bet Builder') {
        this.market.comboType && this.getConflict(!val)
      }
    }
  },
  created() {
    this.onSelectionsChange()
  },
  activated() {
    this.onSelectionsChange()
  },
  methods: {
    onSelectionsChange() {
      const { event, market, outcome } = this
      const selection = convertSelectionOutcome({ outcome, market, event })
      this.active = isSelectedSelection(this.selectionList, selection)
    },
    async toogleSelected(e) {
      e.preventDefault()

      const { market, outcome, event, isDisabled, isLoading, isConflict, keyPoints } = this

      if (!useAuthStore().loginStatus && this.market?.comboType) {
        this.$login()
        return false
      }

      const betBuilderStatus = market?.comboType && isLoading
      if (isDisabled || betBuilderStatus) return false

      // console.log(227, this.isConflict, this.active)
      if (isConflict && !this.active) {
        toast('This selection cannot be combined with the seletcions you have added in betslip.')
        return false
      }

      const active = useWapBetslipStore().toggleSelection({
        outcome: { ...outcome },
        market: { ...market },
        event: { ...event }
      })

      this.active = active
      this.$emit('click', active)

      // 埋点
      if (active && keyPoints) {
        window.mstrace(`${keyPoints}`)
      }
    },
    async getConflict(isDelete = false) {
      try {
        if (!isDelete) {
          const { id, specifiers } = this.market
          const { id: outcomeId } = this.outcome
          const hasMarket = this.curConflictMarkets.some((x) => x.marketId === id && x.specifiers === specifiers && x.outcomeId === outcomeId)
          if (hasMarket) return false
        }

        const marketInfo = [
          {
            outcome: this.outcome,
            market: this.market
          }
        ]
        await useDetailStore().getConflictMarkets(marketInfo, isDelete)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss">
.m-outcome {
  position: relative;
  display: flex;
  width: 64px;
  height: 44px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-left: 2px;
  background: #333;
  color: #ffca27;
  cursor: pointer;
  font-weight: 700;
  line-height: 44px;
  text-align: center;

  &.in-oddsRange {
    border: 1px solid #ffca27;
    background: #2A2518;
    color: #ffca27;
  }

  &.active {
    background: #ffca27;
    color: #333;
  }

  &:first-child {
    margin-left: 0;
  }

  &--up {
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 8px;
      border-radius: 0 0 4px 4px;
      background-image: linear-gradient(0deg, #00B359 0%, rgba(0,179,89,0%) 100%);
      content: "";
      transform: scaleY(-1);
    }
  }

  &--down {
    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 8px;
      border-radius: 0 0 4px 4px;
      background-image: linear-gradient(180deg, rgba(255,56,38,0%) 0%, #FF3826 100%);
      content: "";
    }
  }

  &.disabled {
    color: #888;
    cursor: not-allowed;
  }

  .m-icon-arrow {
    position: absolute;
    right: 50%;
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: -4px;

    &::before {
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border: 4px solid transparent;
      content: '';
    }

    &.up {
      top: 4px;

      &::before {
        border-bottom-color: #00b359;
        margin-top: -2px;
      }
    }

    &.down {
      bottom: 4px;

      &::before {
        border-top-color: #ff3826;
        margin-top: 2px;
      }
    }
  }

  &.multiple {
    height: 36px;
    justify-content: space-between;
    padding: 0 10px;
    margin-right: 4px;
    line-height: 36px;

    &.active {
      .desc {
        color: #999;
      }

      .odds {
        color: #333;
      }
    }

    &:last-child {
      margin-right: 0;
    }

    .desc {
      flex: 1 1 auto;
      color: #b2b2b2;
      font-size: 12px;
      line-height: 14px;
      text-align: left;
    }

    .odds {
      flex: 1 1 auto;
      color: #ffca27;
      font-size: 12px;
      text-align: right;
    }

    &.disabled {
      justify-content: center;
    }
  }

  &.odds-disabled {
    position: relative;
    overflow: hidden;
    background: #999;

    &::after {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
    }

    .odds,
    .desc {
      color: #404040 !important;
    }

    .odds-loading {
      position: absolute;
      top: 0;
      left: -73px;
      width: 100%;
      height: 100%;
      animation: move calc(var(--time) * 1s) linear infinite;
      transform: translateX(0%);

      &::after {
        display: block;
        width: 73px;
        height: 40px;
        background: linear-gradient(287.55deg, rgba(216, 216, 216, 52%) 0%, rgba(238, 238, 238, 0%) 100%);
        content: "";
        transform: skewX(-20deg);
      }

      @keyframes move {
        0% { transform: translateX(0%); }
        100% { transform: translateX(calc(100% + 73px)); }
      }
    }

    &.m-outcome--down, &.m-outcome--up {
      &::after {
        height: 8px;
      }
    }
  }
}

[data-mode="light"] {
  .m-outcome {
    background: #F2F2F2;
    color: #000;

    &.in-oddsRange {
      background: #FFF9E6;
    }

    &.active {
      background: #ffca27;
    }
  }
}
</style>